import React, {Proptype, Component} from 'react';
import classnames from 'classnames';
import {fetchMediaList} from './redux/actions/getMediaList';
import {deleteMedia} from './redux/actions/deleteMedia';
import { connect } from 'react-redux';
import Loading from 'components/UI/Loading';
import {confirm} from 'util/confirm';
import Pagination from "react-js-pagination";
import Picker from 'react-month-picker';
import 'react-month-picker/css/month-picker.css';
import moment from 'moment';
import locale from './locale';
import './Modal.scss';

const MONTHS= ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];

const mapStateToProps = (state) => ({
  user: state.user,
  mediaCenter: state.mediaCenter,
})

const mapDispatchToProps = (dispatch) => {
	return {
    fetchMediaList: (schoolId, opts) => dispatch(fetchMediaList(schoolId, opts)),
    deleteMedia: (index, schoolId, prefix, callback) => dispatch(deleteMedia(index, schoolId, prefix, callback)),
	};
};


class MediaList extends Component {
  constructor(props){
    super(props)

    this.state = {
      photo: [],
      toggleImage: {},
      selectedYear: moment().subtract(1,'months').get('year'),
      selectedMonth: moment().get('month')+1

    }

    this.selectImage = this.selectImage.bind(this)
    this.fetchMedia = this.fetchMedia.bind(this)
    this.onPageChange = this.onPageChange.bind(this)
    this.onDateClicked = this.onDateClicked.bind(this);
    this.onDateSearch = this.onDateSearch.bind(this);

  }

  componentDidMount(){
    this.fetchMedia(1)
  }

  fetchMedia(newPageNumber, newAmountPerPage){
    const {activePage, itemsCountPerPage} = this.props.mediaCenter.pagination;
    const schoolId = localStorage.getItem('schoolId')

    if(this.props.mediaState == 'list'){
      this.props.fetchMediaList(
        schoolId,
        {amount_per_page: newAmountPerPage || itemsCountPerPage, current_page_number: newPageNumber}
      )
    } else if (this.props.mediaState == 'public'){
      this.props.fetchMediaList(
        schoolId,
        {amount_per_page: newAmountPerPage || itemsCountPerPage, current_page_number: newPageNumber, public: 1}
      )
    }
  }

  selectImage(key, photo){
    return () => {
      if(this.props.selectMultiple){
        let photoArr = this.state.photo;
        photoArr.push(photo)

        // this is to remove any duplicates inside the array
        let newArr = Array.from(new Set(photoArr))

        this.setState({
          toggleImage: {
            ...this.state.toggleImage,
            [key]: this.state.toggleImage[key] !== true,
          },
          photo: newArr,
        }, () => {this.props.onFormChange(this.state.photo)})

      } else {
        this.setState({
          toggleImage: {
            [key]: this.state.toggleImage[key] !== true,
          },
          photo: [photo],
        }, () => {this.props.onFormChange(this.state.photo)})
      }
    }
  }

  onPageChange(activePage) {
    if (activePage == this.props.mediaCenter.pagination.activePage) {
      return;
    }

    this.fetchMedia(activePage);
  }

  onDateClicked(){
    this.refs.pickAMonth.show();
  }

  onDateSearch(year, month){
    const {activePage, itemsCountPerPage} = this.props.mediaCenter.pagination;
    const schoolId = localStorage.getItem('schoolId')

    // format month from 3 to 03
    let newMonth = (month < 10) ? '0' + month.toString() : month.toString();
    this.setState({selectedYear: year, selectedMonth: month})
    this.props.fetchMediaList(
      schoolId,
      {
        amount_per_page: itemsCountPerPage,
        current_page_number: activePage,
        year_month: year + newMonth,
      }
    )
  }

  render(){
    const {mediaCenter} = this.props;
    const {activePage, itemsCountPerPage, totalItemsCount} = mediaCenter.pagination;
    const {toggleImage, photo, selectedYear, selectedMonth} = this.state;
    const schoolId = localStorage.getItem('schoolId')

    if(!mediaCenter.list || mediaCenter.fetching){
      return(
        <Loading />
      )
    }

    return(
      <div>
        <span className='pull-left tuitionReceipt' style={{cursor:'pointer', marginRight: '10px'}} onClick={() => {
          this.fetchMedia(1)
        }}><i className='fa icon-folder'></i><span style={{marginLeft:'10px'}}>{__('All Record', locale)}</span></span>

        <div onClick={this.onDateClicked} style={{cursor:'pointer', marginBottom: '20px'}}>
          <i className="fa icon-calendar" aria-hidden="true" />
          <span style={{marginLeft:'10px'}} >{__('Search by Date', 'monthlyFinance')}</span>
        </div>
        <Picker
          ref="pickAMonth"
          years={{min: {year:2014, month:1}, max: {year: moment().subtract(1,'months').get('year'), month:moment().get('month')+1}}}
          value={{year: selectedYear, month: selectedMonth}}
          lang={MONTHS}
          theme="dark"
          onChange={this.onDateSearch}
        >
        </Picker>

        <div className='media-list'>
          {mediaCenter.list.map((photo, index) => {
            return(
              <div className='photo-container' key={index}>
                <img className={classnames('image', { 'active': toggleImage[index] == true })} src={photo.thumbnail_url} onClick={this.selectImage(index, photo)} />
                {this.props.mediaState == 'list' && <i className='fa icon-cancel' onClick={()=>{
                  let regex = /(schools\/.*)/;
                  let prefix = regex.exec(photo.original_url)
                  confirm(__('Proceed to delete image?', locale))
                  .then(() => {
                    this.props.deleteMedia(index, schoolId, {prefix: prefix[0]}, () => {
                      this.fetchMedia(activePage)
                    })
                  })
                  .catch(() => {})
                }}></i>}
              </div>
            )
          })}
        </div>
        <Pagination
          innerClass='pagination pull-right'
          activePage={activePage}
          itemsCountPerPage={itemsCountPerPage}
          totalItemsCount={totalItemsCount}
          pageRangeDisplayed={5}
          onChange={this.onPageChange}
        />
      </div>

    )
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(MediaList)



// WEBPACK FOOTER //
// ./src/template/Modals/MediaCenter/MediaList.js